import { API_ENDPOINTS } from "../../enums/apiUrls";

export const appendRowDataInGsheet = async (
  worksheetId: string,
  sheetName: string,
  data: any[],
): Promise<{ hasError: boolean; response: any }> => {
  try {
    const response = await fetch(API_ENDPOINTS.APPEND_ROW_TO_GSHEET, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        worksheet_id: worksheetId,
        worksheet_name: sheetName,
        data,
      }),
    });
    if (!response.ok) {
      return {
        hasError: true,
        response: response.statusText,
      };
    }
    const apiResponse = await response.json();
    return {
      hasError: false,
      response: apiResponse,
    };
  } catch (error) {
    return {
      hasError: true,
      response: error,
    };
  }
};
